import { memo } from 'react';

import { ThresholdBarTemplate } from './ThresholdBarTemplate.js';
import type { ThresholdBarProps } from './types.js';
import { THRESHOLD_BAR_THICKNESS } from './types/constants.js';

const ThresholdBarInternal = (props: ThresholdBarProps) => {
  const { length, layout = 'vertical' } = props;

  return layout === 'horizontal' ? (
    /* This is needed to adapt the container to the rotated threshold bar */
    <div
      style={{ width: length, height: THRESHOLD_BAR_THICKNESS }}
      role="graphics-symbol"
      aria-label="threshold bar horizontal"
    >
      <ThresholdBarTemplate {...props} />
    </div>
  ) : (
    <div role="graphics-symbol" aria-label="threshold bar vertical">
      <ThresholdBarTemplate {...props} />
    </div>
  );
};

ThresholdBarInternal['displayName'] = 'ThresholdBarInternal';

/**
 * @internal
 */
export const ThresholdBar = memo(ThresholdBarInternal);

ThresholdBar['displayName'] = 'ThresholdBar';
